import { atom } from 'recoil';

const TOCState = atom({
    key: 'TOC',
    default: [],
});

export default TOCState;
